// extracted by mini-css-extract-plugin
export default {"root":"KPijFIKP","tableBlock":"kOHr_pNr","tableBlockNoShrink":"BXBSSNep"};